import React from 'react';

function Navigation() {
    return (
        <div>
            <h1>Navigation</h1>
        </div>
    );
}

export default Navigation;